var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenVerticalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 51,
    viewBox: "0 0 3 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 50V1",
    stroke: "#0ACF91",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVerticalLine);
export default __webpack_public_path__ + "static/media/green_vertical_line.b92106359b5577c943f58e26af30e03b.svg";
export { ForwardRef as ReactComponent };